import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
} from '@angular/forms';

/**
 * Phone number must be 10 characters in length once stripped of parentheses, dashes,
 * periods, or spaces.
 *
 * @usageNotes
 * Can be used with reactive forms and with template-driven forms.
 *
 * @selector appPhoneNumber
 * @returns
 * ```javascript
 * { phoneInvalid: true } | null
 * ```
 */
@Directive({
  selector: '[appPhoneNumber]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: PhoneNumberDirective,
      multi: true,
    },
  ],
})
export class PhoneNumberDirective {
  @Input('appPhoneNumber') phone = '';

  constructor() {}

  validate(control: AbstractControl): ValidationErrors | null {
    return this.phone ? phoneNumberValidator(control) : null;
  }
}

export const PHONE_VALID_REGEX = /^[(]?(\d{3})[-.)]?[ ]?(\d{3})[-.]?(\d{4})\b$/;

/**
 * Phone number must be 10 characters in length once stripped of parentheses, dashes,
 * periods, or spaces.
 *
 * @returns
 * ```javascript
 * { phoneInvalid: true } | null
 * ```
 */
export const phoneNumberValidator = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value;
  const phoneValid = PHONE_VALID_REGEX.test(value);

  return !phoneValid ? { phoneInvalid: true } : null;
};

/**
 * Strips phone number of parentheses, dashes, periods, or spaces.
 *
 * This is required to POST this data to the server.
 *
 * @param phone Phone number to clean up.
 * @returns I.e. 8595551234.
 */
export const stripPhoneNumber = (phone?: string) => {
  if (!phone) {
    return '';
  }

  return phone.replace(PHONE_VALID_REGEX, '$1$2$3');
};
